export default __webpack_public_path__ + "static/media/PNNL_Battelle.1a8c15c1.png";